import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
//
/* jslint browser: true */
//@ts-nocheck
import { CssBaseline, ThemeProvider, StyledEngineProvider } from "client/componentLibrary";
import "flexboxgrid";
import React from "react";
import DocumentTitle from "react-document-title";
import { render } from "react-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import EmployeePasswordChange from "./signInUp/rebrandedLogin/EmployeePasswordChange";
import muiTheme from "./signInUp/rebrandedLogin/loginTheme";
import WorkWithUs from "./signInUp/rebrandedLogin/WorkWithUs";
import * as FullStory from "@fullstory/browser";
import WorkplaceLogin from "signInUp/WorkplaceOSLogin/WorkplaceLogin";
import WorkplaceForgetPassword from "signInUp/WorkplaceOSLogin/ForgetPassword";
import WorkplaceResetPassword from "signInUp/WorkplaceOSLogin/WorkplaceResetPassword";
import WorkplaceSetPassword from "signInUp/WorkplaceOSLogin/WorkplaceSetPassword";
import "componentLibrary/theme/RaiseColors.css";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var envName = "production";
if (window.IN_STAGING) {
  envName = "staging";
}
if (!window.IN_DEBUG_MODE) {
  FullStory.init({
    orgId: "138TQ",
    devMode: window.IN_STAGING
  });
}

/* Add any new routes here */
function App() {
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: "/login",
      children: /*#__PURE__*/_jsx(WorkplaceLogin, {})
    }), /*#__PURE__*/_jsx(Route, {
      path: "/login/:next",
      children: /*#__PURE__*/_jsx(WorkplaceLogin, {})
    }), /*#__PURE__*/_jsx(Route, {
      path: "/raise_login",
      children: /*#__PURE__*/_jsx(WorkplaceLogin, {})
    }), /*#__PURE__*/_jsx(Route, {
      path: "/raise_login/:next",
      children: /*#__PURE__*/_jsx(WorkplaceLogin, {})
    }), /*#__PURE__*/_jsx(Route, {
      path: "/workplace_login",
      children: /*#__PURE__*/_jsx(WorkplaceLogin, {})
    }), /*#__PURE__*/_jsx(Route, {
      path: "/okta_workplace_login",
      children: /*#__PURE__*/_jsx(WorkplaceLogin, {})
    }), /*#__PURE__*/_jsx(Route, {
      component: WorkWithUs,
      path: "/workwithus"
    }), /*#__PURE__*/_jsx(Route, {
      component: EmployeePasswordChange,
      path: "/loginchangepassword"
    }), /*#__PURE__*/_jsx(Route, {
      component: WorkplaceForgetPassword,
      path: "/forgot_password"
    }), /*#__PURE__*/_jsx(Route, {
      render: function render(_ref) {
        var params = _ref.match.params;
        return /*#__PURE__*/_jsx(WorkplaceResetPassword, {
          params: params
        });
      },
      path: "/reset_password/:reset_code/:user_id"
    }), /*#__PURE__*/_jsx(Route, {
      render: function render(_ref2) {
        var params = _ref2.match.params;
        return /*#__PURE__*/_jsx(WorkplaceSetPassword, {
          params: params
        });
      },
      path: "/activate/:activation_code/:user_id/:dealroomId/:user_name/:org_id"
    }), /*#__PURE__*/_jsx(Route, {
      render: function render(_ref3) {
        var params = _ref3.match.params;
        return /*#__PURE__*/_jsx(WorkplaceSetPassword, {
          params: params
        });
      },
      path: "/activate/:activation_code/:user_id/:user_name/:org_id"
    })]
  });
}
render(/*#__PURE__*/_jsx(_Fragment, {
  children: /*#__PURE__*/_jsx(DocumentTitle, {
    title: "Login",
    children: /*#__PURE__*/_jsx(StyledEngineProvider, {
      injectFirst: true,
      children: /*#__PURE__*/_jsxs(ThemeProvider, {
        theme: muiTheme,
        children: [/*#__PURE__*/_jsx(CssBaseline, {}), /*#__PURE__*/_jsx(BrowserRouter, {
          basename: "",
          children: /*#__PURE__*/_jsx(Route, {
            component: App
          })
        })]
      })
    })
  })
}), document.getElementById("reactbody"));